import { Map } from 'immutable';

import { CLOSE_MODAL, OPEN_MODAL } from './types';

export * from './actions';

export default (state = Map(), { type, payload }) => {
  switch (type) {
    case OPEN_MODAL:
      return state.withMutations((mutableState) =>
        mutableState
          .setIn([payload.name, 'isOpen'], true)
          .setIn([payload.name, 'props'], payload.props),
      );
    case CLOSE_MODAL:
      return state.withMutations((mutableState) =>
        mutableState
          .setIn([payload.name, 'isOpen'], false)
          .setIn([payload.name, 'props'], undefined),
      );

    default:
      return state;
  }
};
